module.exports = __webpack_public_path__ + "static/img/stat-list.e0168d6a.png";